
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import { Counter } from 'react-powerplug'
import Notification from './notification'
import SlimButton from '../slim-button/slim-button'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "notification"
    }}>{`Notification`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Feedback`}</p>
    <hr />
    <h2 {...{
      "id": "notification-1"
    }}>{`Notification`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For communicating helpful information. Notifications often appear inline, nearby where a change has taken place. They automatically disappear after a few seconds.`}</p>
    <Playground __position={1} __code={'<Counter initial={null}>\n  {({ count, inc, dec }) => (\n    <>\n      <div style={{ display: \'flex\', width: \'50%\' }}>\n        <Notification\n          notificationId={count}\n          text=\"Temporary notification text.\"\n          time={4000}\n        />\n      </div>\n      <div\n        style={{\n          display: \'flex\',\n          justifyContent: \'flex-end\',\n          marginTop: \'20px\',\n        }}\n      >\n        <SlimButton\n          secondary\n          onClick={() => {\n            inc()\n          }}\n        >\n          Show notification\n        </SlimButton>\n      </div>\n    </>\n  )}\n</Counter>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Counter,
      Notification,
      SlimButton
    }} mdxType="Playground">
    <Counter initial={null} mdxType="Counter">
      {({
          count,
          inc,
          dec
        }) => <>
          <div style={{
            display: 'flex',
            width: '50%'
          }}>
            <Notification notificationId={count} text='Temporary notification text.' time={4000} mdxType="Notification" />
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px'
          }}>
              <SlimButton secondary onClick={() => {
              inc();
            }} mdxType="SlimButton">
                 Show notification
              </SlimButton>
          </div>
        </>}
    </Counter>
    </Playground>
    <p><strong parentName="p">{`Success`}</strong></p>
    <Playground __position={2} __code={'<Counter initial={null}>\n  {({ count, inc, dec }) => (\n    <>\n      <div style={{ display: \'flex\', width: \'50%\' }}>\n        <Notification\n          notificationId={count}\n          text=\"Temporary notification text.\"\n          time={4000}\n          variant=\"success\"\n        />\n      </div>\n      <div\n        style={{\n          display: \'flex\',\n          justifyContent: \'flex-end\',\n          marginTop: \'20px\',\n        }}\n      >\n        <SlimButton\n          secondary\n          onClick={() => {\n            inc()\n          }}\n        >\n          Show notification\n        </SlimButton>\n      </div>\n    </>\n  )}\n</Counter>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Counter,
      Notification,
      SlimButton
    }} mdxType="Playground">
    <Counter initial={null} mdxType="Counter">
      {({
          count,
          inc,
          dec
        }) => <>
          <div style={{
            display: 'flex',
            width: '50%'
          }}>
            <Notification notificationId={count} text='Temporary notification text.' time={4000} variant='success' mdxType="Notification" />
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px'
          }}>
              <SlimButton secondary onClick={() => {
              inc();
            }} mdxType="SlimButton">
                 Show notification
              </SlimButton>
          </div>
        </>}
    </Counter>
    </Playground>
    <p><strong parentName="p">{`Warning`}</strong></p>
    <Playground __position={3} __code={'<Counter initial={null}>\n  {({ count, inc, dec }) => (\n    <>\n      <div style={{ display: \'flex\', width: \'50%\' }}>\n        <Notification\n          notificationId={count}\n          text=\"Temporary notification text.\"\n          time={4000}\n          variant=\"warning\"\n        />\n      </div>\n      <div\n        style={{\n          display: \'flex\',\n          justifyContent: \'flex-end\',\n          marginTop: \'20px\',\n        }}\n      >\n        <SlimButton\n          secondary\n          onClick={() => {\n            inc()\n          }}\n        >\n          Show notification\n        </SlimButton>\n      </div>\n    </>\n  )}\n</Counter>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Counter,
      Notification,
      SlimButton
    }} mdxType="Playground">
    <Counter initial={null} mdxType="Counter">
      {({
          count,
          inc,
          dec
        }) => <>
          <div style={{
            display: 'flex',
            width: '50%'
          }}>
            <Notification notificationId={count} text='Temporary notification text.' time={4000} variant='warning' mdxType="Notification" />
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px'
          }}>
              <SlimButton secondary onClick={() => {
              inc();
            }} mdxType="SlimButton">
                 Show notification
              </SlimButton>
          </div>
        </>}
    </Counter>
    </Playground>
    <p><strong parentName="p">{`Error`}</strong></p>
    <Playground __position={4} __code={'<Counter initial={null}>\n  {({ count, inc, dec }) => (\n    <>\n      <div style={{ display: \'flex\', width: \'50%\' }}>\n        <Notification\n          notificationId={count}\n          text=\"Temporary notification text.\"\n          time={4000}\n          variant=\"error\"\n        />\n      </div>\n      <div\n        style={{\n          display: \'flex\',\n          justifyContent: \'flex-end\',\n          marginTop: \'20px\',\n        }}\n      >\n        <SlimButton\n          secondary\n          onClick={() => {\n            inc()\n          }}\n        >\n          Show notification\n        </SlimButton>\n      </div>\n    </>\n  )}\n</Counter>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Counter,
      Notification,
      SlimButton
    }} mdxType="Playground">
    <Counter initial={null} mdxType="Counter">
      {({
          count,
          inc,
          dec
        }) => <>
          <div style={{
            display: 'flex',
            width: '50%'
          }}>
            <Notification notificationId={count} text='Temporary notification text.' time={4000} variant='error' mdxType="Notification" />
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px'
          }}>
              <SlimButton secondary onClick={() => {
              inc();
            }} mdxType="SlimButton">
                 Show notification
              </SlimButton>
          </div>
        </>}
    </Counter>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Notification} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;